import React from 'react';
import { Link } from 'react-router-dom';

const SignUpPromptModal = ({ onClose, context = 'powerup', guestDailyGameLimit = 3 }) => {
  const isGuestLimit = context === 'guest_limit';
  const isGuestPowerupLimit = context === 'guest_powerup_limit';
  const title = isGuestLimit
    ? "You've reached today's free guest limit"
    : isGuestPowerupLimit
      ? "You used today's free guest powerups"
      : 'Create an account to use this';
  const message = isGuestLimit
    ? `Guests can play ${guestDailyGameLimit} Unlimited games per day. Sign up to keep playing, save progress, and earn coins.`
    : isGuestPowerupLimit
      ? 'Guests get 2 free Inspects + 2 free Zoom Outs per UTC day. Create a free account to keep using powerups, save progress, and earn coins.'
      : 'Skips and Inspects are account features. Sign up to save progress, earn coins, and unlock these controls.';
  const primaryLabel = isGuestPowerupLimit ? 'Create free account' : 'Sign up / Log in';

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
        <h2>{title}</h2>
        <p>{message}</p>
        <div className="modal-buttons">
          <Link to="/auth" className="modal-button" onClick={onClose}>
            {primaryLabel}
          </Link>
          <button className="modal-button" onClick={onClose}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignUpPromptModal;
